<script setup>
import { computed } from 'vue';
import { Handle, Position } from '@vue-flow/core';
import { NODE_TYPES } from '../../constants';
import FlowNodeCard from './FlowNodeCard.vue';

const props = defineProps({
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});
const meta = NODE_TYPES.http_request;
const preview = computed(() => props.data.url || '(sem URL ainda)');
</script>

<template>
  <FlowNodeCard :icon="meta.icon" :color="meta.color" :title="meta.label" :selected="selected">
    <Handle type="target" :position="Position.Left" />
    <p class="uppercase text-[10px] font-semibold text-n-slate-9">{{ data.method || 'get' }}</p>
    <p class="line-clamp-2 break-all">{{ preview }}</p>
    <Handle type="source" :position="Position.Right" />
  </FlowNodeCard>
</template>
